export default "__VITE_ASSET__025ae422__"